import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import React, { useState, useEffect } from "react";
import HeaderExtra from '../components/HeaderExtra.jsx'
import FooterExtraPage from '../components/FooterExtraPage.jsx'

import  '../Assets/js/generalui.js'
import  '../Assets/js/extrapage.js'
import  '../Assets/css/extrapage.css'

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;

function ExtraPageElements()
{
  useEffect(() =>
  {

  }, []);

  // Append Body Element To 'root' -----------------------------------------------------
  return(
    <div className="basic">

      <div className="BasicBlackBlocker" style={{display:"none"}}>
        <div className='FlexFullDisplayPanel HideScrollBar BasicRadius' style={{maxHeight:"none"}}>
          <div className='FlexContainerBaseAnimate RowGapBasic' style={{display:"none"}}>

            <div style={{width:"100%", height:"fit-content", margin:"0 auto", flexDirection:"column", display:"flex"}}>
              <img src="/Assets/images/ButtonIcon/cancel-x-grey.svg" className="CloseButtonInsidePanel" style={{marginLeft:"auto"}} />
              <p className="MidSizeText InterSuperBoldTextFont" style={{margin:"0 auto"}}>Halo, Mitra PinginGo!</p>
              <p className="MidSizeText3 InterRegularTextFont" style={{margin:"0 auto"}}>Beri tahu kami jenis akomodasi Anda</p>
            </div>

            <div className='BasicSizePopUpPanelWrapper RowGapBasic HideScrollBar' style={{display:"none"}}>
              <div className="BasicScrollableContainer MidHeightScrollMaxContainer MaskOnlyButton HideScrollBar ThinPaddingWrapper">
                
                <label className="AccomodationTypeListingChoiceContainer BasicMarginBottom BasicPaddingWrapper BasicRadius BasicThinGreyBorder ColumnGapBasic2 Selectable">
                  <input type="radio" name="TypeOfAccomodationBermitra" className="TypeBermitraCheckBox" value="Glamping"/>
                  <img src="/Assets/images/ExtraPage/MitraTypeChoiceImage/Glamping.png" className="FormSelectionHotelImage BasicRadius"/>
                  <div className="FormTypeDescriptionWrapper">
                    <p className="InterBoldTextFont MidSizeText">Camp Ground</p>
                    <p className="InterRegularTextFont MidSizeText2" style={{color: "rgb(102, 112, 133)", margin: "0px"}}>Campground menyediakan area camping yang bisa disewa untuk pengalaman berkemah yang seru dan nyaman.</p>
                  </div>
                </label>

                <label className="AccomodationTypeListingChoiceContainer BasicMarginBottom BasicPaddingWrapper BasicRadius BasicThinGreyBorder ColumnGapBasic2 Selectable">
                  <input type="radio" name="TypeOfAccomodationBermitra" className="TypeBermitraCheckBox" value="Ressort"/>
                  <img src="/Assets/images/ExtraPage/MitraTypeChoiceImage/Ressort.png" className="FormSelectionHotelImage BasicRadius"/>
                  <div className="FormTypeDescriptionWrapper">
                    <p className="InterBoldTextFont MidSizeText">Ressort</p>
                    <p className="InterRegularTextFont MidSizeText2" style={{color: "rgb(102, 112, 133)", margin: "0px"}}>PinginGo Resort menyewakan penginapan eksklusif di alam dengan fasilitas lengkap untuk liburan nyaman dan berkesan! 🌿🏡✨</p>
                  </div>
                </label>

                <label className="AccomodationTypeListingChoiceContainer BasicMarginBottom BasicPaddingWrapper BasicRadius BasicThinGreyBorder ColumnGapBasic2 Selectable">
                  <input type="radio" name="TypeOfAccomodationBermitra" className="TypeBermitraCheckBox" value="Villa"/>
                  <img src="/Assets/images/ExtraPage/MitraTypeChoiceImage/Villa.png" className="FormSelectionHotelImage BasicRadius"/>
                  <div className="FormTypeDescriptionWrapper">
                    <p className="InterBoldTextFont MidSizeText">Villa</p>
                    <p className="InterRegularTextFont MidSizeText2" style={{color: "rgb(102, 112, 133)", margin: "0px"}}>PinginGo Villa menyewakan villa eksklusif dengan suasana alam dan fasilitas lengkap untuk liburan nyaman dan private! 🌿🏡✨</p>
                  </div>
                </label>

                <label className="AccomodationTypeListingChoiceContainer BasicMarginBottom BasicPaddingWrapper BasicRadius BasicThinGreyBorder ColumnGapBasic2 Selectable">
                  <input type="radio" name="TypeOfAccomodationBermitra" className="TypeBermitraCheckBox" value="Hotels"/>
                  <img src="/Assets/images/ExtraPage/MitraTypeChoiceImage/Hotels.png" className="FormSelectionHotelImage BasicRadius"/>
                  <div className="FormTypeDescriptionWrapper">
                    <p className="InterBoldTextFont MidSizeText">Hotels</p>
                    <p className="InterRegularTextFont MidSizeText2" style={{color: "rgb(102, 112, 133)", margin: "0px"}}>PinginGo Hotel menyewakan kamar hotel nyaman dengan fasilitas lengkap, cocok untuk liburan atau perjalanan bisnis! 🏨✨</p>
                  </div>
                </label>

                <label className="AccomodationTypeListingChoiceContainer BasicMarginBottom BasicPaddingWrapper BasicRadius BasicThinGreyBorder ColumnGapBasic2 Selectable">
                  <input type="radio" name="TypeOfAccomodationBermitra" className="TypeBermitraCheckBox" value="Cabin"/>
                  <img src="/Assets/images/ExtraPage/MitraTypeChoiceImage/Cabin.png" className="FormSelectionHotelImage BasicRadius"/>
                  <div className="FormTypeDescriptionWrapper">
                    <p className="InterBoldTextFont MidSizeText">Cabin</p>
                    <p className="InterRegularTextFont MidSizeText2" style={{color: "rgb(102, 112, 133)", margin: "0px"}}>PinginGo Cabin menyewakan kabin nyaman di tengah alam, cocok untuk liburan tenang dengan suasana hangat dan fasilitas lengkap! 🌲🏡✨</p>
                  </div>
                </label>

                <label className="AccomodationTypeListingChoiceContainer BasicMarginBottom BasicPaddingWrapper BasicRadius BasicThinGreyBorder ColumnGapBasic2 Selectable OtherTypeAccListing">
                  <input type="radio" name="TypeOfAccomodationBermitra" className="TypeBermitraCheckBox" value="Glamping"/>
                  <img src="/Assets/images/ExtraPage/MitraTypeChoiceImage/Others.svg" className="FormSelectionHotelImage BasicRadius"/>
                  <div className="FormTypeDescriptionWrapper RowGapBasic4">
                    <p className="InterBoldTextFont MidSizeText">Jenis Lainnya</p>
                    <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                      <input type="email" name="Email" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="Beri tahu kami jenis akomodasi Anda"/>
                    </div>
                  </div>
                </label>
                
              </div>
                <button className='BigUIButton BasicRadius OrangeButton ExtendedButton Selectable' style={{margin:"0 auto"}}>
                  <p className='InterMediumTextFont'>Lanjutkan</p>
                </button>
            </div>

            <div className='BasicSizePopUpPanelWrapper RowGapBasic5 HideScrollBar' style={{display:"none"}}>
              <div className="BasicScrollableContainer MidHeightScrollMaxContainer MaskOnlyButton HideScrollBar ThinPaddingWrapper" style={{minHeight:"0"}}>
                <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                  <input type="text" name="NamaAkomodasiListing" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="Misalnya: Luxury Glamping"/>
                </div>
              </div>
              <div className='ColumnGapBasic2' style={{display:"flex", margin:"0 auto"}}>
                <button className='MidUIButton BasicRadius GreyOutlineButton ExtendedButton Selectable'>
                  <p className='InterMediumTextFont'>Kembali</p>
                </button>
                <button className='MidUIButton BasicRadius OrangeButton ExtendedButton Selectable'>
                  <p className='InterMediumTextFont'>Berikutnya</p>
                </button>
              </div>
            </div>

            <div className='BasicSizePopUpPanelWrapper RowGapBasic5 HideScrollBar' style={{display:"none"}}>
              <div className="BasicScrollableContainer MidHeightScrollMaxContainer HideScrollBar ThinPaddingWrapper RowGapBasic5" style={{minHeight:"0", flexDirection:"column", display:"flex"}}>

                <div style={{flex: 1, height:"fit-content", display:"flex"}} className='ColumnGapBasic2'>
                  <div style={{width: "auto", minWidth: "0", display:"flex", flex:"1", flexDirection:"column"}} className='RowGapBasic4'>
                    <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>Provinsi <span style={{color: "#c10000"}}>*</span></p>
                    <div className="BasicInputFieldContainer" style={{width: "auto", minWidth: "0", display:"flex", flex:"1"}}>
                      <div className="SmallPanelDropDownInputWrapper Selectable3 BasicRadius BasicGreyBorder InputFieldPadding ColumnGapBasic2">
                        <input type="text" name="NamaAkomodasiListing" className="InterMediumTextFont MidSizeText2" placeholder="-----"/>
                        <img className="ChevronInsideInput ToggleArrow" id="ProvinceChevronBermitra" src="/Assets/images/ButtonIcon/chevron.svg" style={{rotate: "0deg"}}/>
                      </div>
                      {/* <div className='ContainerFlex'>
                        <div className='DropDownContainer HideScrollBar'>
                          <div className='DropDownSelectionContainer DropDownSelectionContainerSelected Selectable4'>
                            <p className='MidSizeText3 DropDownSelectionText'>This Choice 1</p>
                          </div>
                          <div className='DropDownSelectionContainer Selectable4'>
                            <p className='MidSizeText3 DropDownSelectionText'>This Choice 2</p>
                          </div>
                          <div className='DropDownSelectionContainer Selectable4'>
                            <p className='MidSizeText3 DropDownSelectionText'>This Choice 2</p>
                          </div>
                        </div>
                      </div> */}
                    </div>
                    <div className='WarningTextImgWrapper ColumnGapBasic4'>
                      <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                      <p className='SmallSizeText InterMediumTextFont'>Provinsi tidak boleh Kosong</p>
                    </div>
                  </div>
                  <div style={{width: "auto", minWidth: "0", display:"flex", flex:"1", flexDirection:"column"}} className='RowGapBasic4'>
                    <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>Wilayah Kota <span style={{color: "#c10000"}}>*</span></p>
                    <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder" style={{width: "auto", minWidth: "0", display:"flex", flex:"1"}}>
                      <div className="SmallPanelDropDownInputWrapper Selectable3 InputFieldPadding ColumnGapBasic2">
                        <input type="text" name="NamaAkomodasiListing" className="InterMediumTextFont MidSizeText2" placeholder="-----"/>
                        <img className="ChevronInsideInput ToggleArrow" id="ProvinceChevronBermitra" src="/Assets/images/ButtonIcon/chevron.svg" style={{rotate: "0deg"}}/>
                      </div>
                    </div>
                    <div className='WarningTextImgWrapper ColumnGapBasic4'>
                      <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                      <p className='SmallSizeText InterMediumTextFont'>Wilayah Kota tidak boleh Kosong</p>
                    </div>
                  </div>
                </div>


                <div style={{flex: 1, height:"fit-content", display:"flex", flexDirection:"column"}} className='RowGapBasic4'>
                  <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>Alamat Lengkap <span style={{color: "#c10000"}}>*</span></p>
                  <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                    <input type="text" name="AlamatLengkap" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="Masukkan alamat lengkap akomodasi"/>
                  </div>
                  <div className='WarningTextImgWrapper ColumnGapBasic4'>
                    <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                    <p className='SmallSizeText InterMediumTextFont'>Wilayah Kota tidak boleh Kosong</p>
                  </div>
                </div>

                <div style={{flex: 1, height:"fit-content", display:"flex", flexDirection:"column"}} className='RowGapBasic4'>
                  <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>Tautan Google Maps <span style={{color: "#c10000"}}>*</span></p>
                  <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                    <input type="text" name="AlamatLengkap" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="Misalnya: https://maps.app.goo.gl/YP5jR5jGQrymsKWHA"/>
                  </div>
                  <div className='WarningTextImgWrapper ColumnGapBasic'>
                    <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                    <p className='SmallSizeText InterMediumTextFont'>Alamat Lengkap tidak boleh Kosong</p>
                  </div>
                </div>

              </div>
              <div className='ColumnGapBasic2' style={{display:"flex", margin:"0 auto"}}>
                <button className='MidUIButton BasicRadius GreyOutlineButton ExtendedButton Selectable'>
                  <p className='InterMediumTextFont'>Kembali</p>
                </button>
                <button className='MidUIButton BasicRadius OrangeButton ExtendedButton Selectable'>
                  <p className='InterMediumTextFont'>Berikutnya</p>
                </button>
              </div>
            </div>

            <div className='BasicSizePopUpPanelWrapper RowGapBasic5 HideScrollBar' style={{display:"none"}}>
              <div className="BasicScrollableContainer MidHeightScrollMaxContainer HideScrollBar ThinPaddingWrapper RowGapBasic5" style={{minHeight:"0", flexDirection:"column", display:"flex"}}>

                <div style={{flex: 1, height:"fit-content", display:"flex", flexDirection:"column"}} className='RowGapBasic4'>
                  <p className="MidSizeText InterBoldTextFont" style={{color:"#344054"}}>Foto Akomodasi <span className='InterMediumTextFont' style={{color: "#c10000"}}>*</span></p>
                  <p className="SmallSizeText InterMediumTextFont" style={{color:"rgb(109, 109, 109)"}}>Tambahkan foto akomodasi Anda di sini, dan Anda dapat mengunggah maksimal 10 file dan minimal 1 foto</p>
                </div>

                <div className="BlueStripBorder WhiteContentWrapperPadding BasicRadius ContainerHoverable" style={{cursor: "pointer", width:"auto", height:"fit-content"}}>
                  <div className="ContentHovTarget" id="UploadPhotoHereContentWrapper" style={{width:"fit-content", height:"fit-content", display:"flex", flexDirection:"column", margin:"auto"}}>
                    <img className="BiggestSizeIcon" src="/Assets/images/ButtonIcon/upload-cloud-blue.svg" style={{margin:"0 auto"}}/>
                    <p className="SpecialMidSizeText3 RobotoBoldTextFont" style={{color: "rgb(11, 11, 11)", margin:"0 auto"}}>Seret file Anda atau <span style={{color: "#1849D6", margin:"0 auto"}} className="HyperlinkUnderlineText">Telusuri</span></p>
                    <p className="SmallSizeText RobotoTextFont" style={{marginTop: "0px", color: "rgb(109, 109, 109)", margin:"0 auto"}}>Ukuran file yang diizinkan maksimal 10 MB</p>
                  </div>
                </div>
                
                <div className="ListOfUploadedPhotoSwiperContainer">
                  <div className="swiper-wrapper">

                    <div className="ListOfUploadedPhotoSwiper BasicRadius BasicLightGreyBorder BasicPaddingWrapper">
                      <div className='ColumnGapBasic' style={{flex: 1, height: "fit-content", display: "flex"}}>
                        <img className="BiggestSizeIcon BasicRadius" src="/Assets/images/NoHotelImage.jpg" style={{backgroundColor:"red", objectFit:"cover"}}/>
                        <div className="ListOfUploadedBermitraTextWrapper">
                          <p className="MidSizeText2 RobotoBoldTextFont">BlackPingShare.png</p>
                          <p className="SmallSizeText RobotoTextFont">3.71 KB</p>
                        </div>
                        <img className="BiggerSizeIcon Selectable2" src="/Assets/images/ButtonIcon/x-delete-swiper.svg"/>
                      </div>
                      <div className="ProgressUploadWrapper">
                        <div className="ProgressUploadContainer">
                          <div className="ProgressUploadBlue"></div>
                        </div>
                        <div className="MidSizeText3 RobotoBoldTextFont">100%</div>
                      </div>
                    </div>

                    <div className="ListOfUploadedPhotoSwiper BasicRadius BasicLightGreyBorder BasicPaddingWrapper">
                      <div className='ColumnGapBasic' style={{flex: 1, height: "fit-content", display: "flex"}}>
                        <img className="BiggestSizeIcon BasicRadius" src="/Assets/images/NoHotelImage.jpg" style={{backgroundColor:"red", objectFit:"cover"}}/>
                        <div className="ListOfUploadedBermitraTextWrapper">
                          <p className="MidSizeText2 RobotoBoldTextFont">TestShare.png</p>
                          <p className="SmallSizeText RobotoTextFont">3.71 KB</p>
                        </div>
                        <img className="BiggerSizeIcon Selectable2" src="/Assets/images/ButtonIcon/x-delete-swiper.svg"/>
                      </div>
                      <div className="ProgressUploadWrapper">
                        <div className="ProgressUploadContainer">
                          <div className="ProgressUploadBlue"></div>
                        </div>
                        <div className="MidSizeText3 RobotoBoldTextFont">100%</div>
                      </div>
                    </div>

                  </div>
                </div>

                <div style={{flex: 1, height:"fit-content", display:"flex", flexDirection:"column"}} className='RowGapBasic4'>
                  <p className="MidSizeText InterBoldTextFont" style={{color:"#344054"}}>Media Sosial Akomodasi <span className='InterMediumTextFont' style={{color: "#c10000"}}>*</span></p>
                  <p className="SmallSizeText InterMediumTextFont" style={{color:"rgb(109, 109, 109)"}}>Tambahkan media sosial akomodasi Anda, baik tiktok atau instagram.</p>
                </div>

                <div style={{flex: 1, height:"fit-content", display:"flex", flexDirection:"column"}} className='RowGapBasic4'>
                  <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>Instagram</p>
                  <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                    <div className='InputFieldPadding ColumnGapBasic' style={{display:"flex"}}>
                      <img src="/Assets/images/ButtonIcon/Social/ig-instagram-icon.svg" className='BigSizeIcon' />
                      <input type="text" name="TiktokURL" className="MidSizeText2 InterMediumTextFont" placeholder="Misalnya: https://www.instagram.com/pingingo.official/" style={{flex:1, height:"fit-content"}}/>
                    </div>
                  </div>
                  <div className='WarningTextImgWrapper ColumnGapBasic4'>
                    <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                    <p className='SmallSizeText InterMediumTextFont'>Wilayah Kota tidak boleh Kosong</p>
                  </div>
                </div>

                <div style={{flex: 1, height:"fit-content", display:"flex", flexDirection:"column"}} className='RowGapBasic4'>
                  <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>TikTok</p>
                  <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                    <div className='InputFieldPadding ColumnGapBasic' style={{display:"flex"}}>
                      <img src="/Assets/images/ButtonIcon/Social/tiktok-square-color-icon.svg" className='BigSizeIcon' />
                      <input type="text" name="TiktokURL" className="MidSizeText2 InterMediumTextFont" placeholder="Misalnya: https://www.tiktok.com/@pingingo.official" style={{flex:1, height:"fit-content"}}/>
                    </div>
                  </div>
                  <div className='WarningTextImgWrapper ColumnGapBasic'>
                    <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                    <p className='SmallSizeText InterMediumTextFont'>Alamat Lengkap tidak boleh Kosong</p>
                  </div>
                </div>

              </div>
              <div className='ColumnGapBasic2' style={{display:"flex", margin:"0 auto"}}>
                <button className='MidUIButton BasicRadius GreyOutlineButton ExtendedButton Selectable'>
                  <p className='InterMediumTextFont'>Kembali</p>
                </button>
                <button className='MidUIButton BasicRadius OrangeButton ExtendedButton Selectable'>
                  <p className='InterMediumTextFont'>Berikutnya</p>
                </button>
              </div>
            </div>

            <div className='BasicSizePopUpPanelWrapper RowGapBasic5 HideScrollBar' id='PricingSectionWrapper' style={{display:"none"}}>
              <div className="BasicScrollableContainer MidHeightScrollMaxContainer HideScrollBar ThinPaddingWrapper RowGapBasic5" style={{minHeight:"0", flexDirection:"column", display:"flex"}}>

                <div style={{flex: 1, height:"fit-content", display:"flex", flexDirection:"column"}} className='RowGapBasic4'>
                  <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>Jumlah Kamar <span style={{color: "#c10000"}}>*</span></p>
                  <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                    <input type="number" name="AlamatLengkap" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="Masukkan jumlah kamar"/>
                  </div>
                  <div className='WarningTextImgWrapper ColumnGapBasic4'>
                    <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                    <p className='SmallSizeText InterMediumTextFont'>Wilayah Kota tidak boleh Kosong</p>
                  </div>
                </div>

                <div className='RowGapBasic4' style={{flex: 1, height:"fit-content", display:"flex", flexDirection:"column"}}>
                  <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>Tarif Kamar <span style={{color: "#c10000"}}>*</span></p>
                  <div style={{flex: 1, height:"fit-content", display:"flex"}} className='ColumnGapBasic'>
                    <div style={{width: "auto", minWidth: "0", display:"flex", flex:"1", flexDirection:"column"}} className='RowGapBasic4'>
                      <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                        <div className='SmallTextContainerInsideInputField BasicRadius'>
                          <p className='MidSizeText2 InterMediumTextFont' style={{color:"#667085"}}>Rp</p>
                        </div>
                        <input type="number" name="RoomPriceFrom" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="100,000"/>
                      </div>
                      <div className='WarningTextImgWrapper ColumnGapBasic4'>
                        <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                        <p className='SmallSizeText InterMediumTextFont'>Provinsi tidak boleh Kosong</p>
                      </div>
                    </div>
                    <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054", margin:"auto 0"}}>sampai</p>
                    <div style={{width: "auto", minWidth: "0", display:"flex", flex:"1", flexDirection:"column"}} className='RowGapBasic4'>
                      <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                        <div className='SmallTextContainerInsideInputField BasicRadius'>
                          <p className='MidSizeText2 InterMediumTextFont' style={{color:"#667085"}}>Rp</p>
                        </div>
                        <input type="number" name="RoomPriceFrom" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="1,000,000"/>
                      </div>
                      <div className='WarningTextImgWrapper ColumnGapBasic4'>
                        <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                        <p className='SmallSizeText InterMediumTextFont'>Provinsi tidak boleh Kosong</p>
                      </div>
                    </div>
                  </div>
                </div>



              </div>
              <div className='ColumnGapBasic2' style={{display:"flex", margin:"0 auto"}}>
                <button className='MidUIButton BasicRadius GreyOutlineButton ExtendedButton Selectable'>
                  <p className='InterMediumTextFont'>Kembali</p>
                </button>
                <button className='MidUIButton BasicRadius OrangeButton ExtendedButton Selectable'>
                  <p className='InterMediumTextFont'>Berikutnya</p>
                </button>
              </div>
            </div>

            <div className='BasicSizePopUpPanelWrapper RowGapBasic5 HideScrollBar' id='UserInputSectionWrapper'>
              <div className="BasicScrollableContainer MidHeightScrollMaxContainer HideScrollBar ThinPaddingWrapper RowGapBasic5" style={{minHeight:"0", flexDirection:"column", display:"flex"}}>


                <div style={{flex: 1, height:"fit-content", display:"flex"}} className='ColumnGapBasic2'>
                  <div style={{width: "auto", minWidth: "0", display:"flex", flex:"1", flexDirection:"column"}} className='RowGapBasic4'>
                    <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>Nama Lengkap <span style={{color: "#c10000"}}>*</span></p>
                    <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                      <input type="number" name="DepartmentName" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="Masukkan Nama Lengkap"/>
                    </div>
                    <div className='WarningTextImgWrapper ColumnGapBasic4'>
                      <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                      <p className='SmallSizeText InterMediumTextFont'>Provinsi tidak boleh Kosong</p>
                    </div>
                  </div>
                  <div style={{width: "auto", minWidth: "0", display:"flex", flex:"1", flexDirection:"column"}} className='RowGapBasic4'>
                    <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>Wilayah Kota <span style={{color: "#c10000"}}>*</span></p>
                    <div className="BasicInputFieldContainer" style={{width: "auto", minWidth: "0", display:"flex", flex:"1"}}>
                      <div className="SmallPanelDropDownInputWrapper Selectable3 BasicRadius BasicGreyBorder InputFieldPadding ColumnGapBasic2">
                        <input type="text" name="NamaAkomodasiListing" className="InterMediumTextFont MidSizeText2" placeholder="-----"/>
                        <img className="ChevronInsideInput ToggleArrow" id="ProvinceChevronBermitra" src="/Assets/images/ButtonIcon/chevron.svg" style={{rotate: "0deg"}}/>
                      </div>
                    </div>
                    <div className='WarningTextImgWrapper ColumnGapBasic4'>
                      <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                      <p className='SmallSizeText InterMediumTextFont'>Wilayah Kota tidak boleh Kosong</p>
                    </div>
                  </div>
                </div>

                <div className='RowGapBasic4' style={{flex: 1, height:"fit-content", display:"flex", flexDirection:"column"}}>
                  <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>Tarif Kamar <span style={{color: "#c10000"}}>*</span></p>
                  <div style={{flex: 1, height:"fit-content", display:"flex"}} className='ColumnGapBasic'>
                    <div style={{width: "auto", minWidth: "0", display:"flex", flex:"1", flexDirection:"column"}} className='RowGapBasic4'>
                      <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                        <div className='SmallTextContainerInsideInputField BasicRadius'>
                          <p className='MidSizeText2 InterMediumTextFont' style={{color:"#667085"}}>Rp</p>
                        </div>
                        <input type="number" name="RoomPriceFrom" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="100,000"/>
                      </div>
                      <div className='WarningTextImgWrapper ColumnGapBasic4'>
                        <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                        <p className='SmallSizeText InterMediumTextFont'>Provinsi tidak boleh Kosong</p>
                      </div>
                    </div>
                    <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054", margin:"auto 0"}}>sampai</p>
                    <div style={{width: "auto", minWidth: "0", display:"flex", flex:"1", flexDirection:"column"}} className='RowGapBasic4'>
                      <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                        <div className='SmallTextContainerInsideInputField BasicRadius'>
                          <p className='MidSizeText2 InterMediumTextFont' style={{color:"#667085"}}>Rp</p>
                        </div>
                        <input type="number" name="RoomPriceFrom" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="1,000,000"/>
                      </div>
                      <div className='WarningTextImgWrapper ColumnGapBasic4'>
                        <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                        <p className='SmallSizeText InterMediumTextFont'>Provinsi tidak boleh Kosong</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{flex: 1, height:"fit-content", display:"flex", flexDirection:"column"}} className='RowGapBasic4'>
                  <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>Departemen <span style={{color: "#c10000"}}>*</span></p>
                  <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                    <input type="number" name="DepartmentName" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="Misalnya: Pemilik, Manajer"/>
                  </div>
                  <div className='WarningTextImgWrapper ColumnGapBasic4'>
                    <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                    <p className='SmallSizeText InterMediumTextFont'>Wilayah Kota tidak boleh Kosong</p>
                  </div>
                </div>

                <div style={{flex: 1, height:"fit-content", display:"flex", flexDirection:"column"}} className='RowGapBasic4'>
                  <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>E-mail <span style={{color: "#c10000"}}>*</span></p>
                  <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                    <input type="email" name="Email" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="Misalnya: test@gmail.com"/>
                  </div>
                  <div className='WarningTextImgWrapper ColumnGapBasic4'>
                    <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                    <p className='SmallSizeText InterMediumTextFont'>Wilayah Kota tidak boleh Kosong</p>
                  </div>
                </div>

                <div style={{flex: 1, height:"fit-content", display:"flex", flexDirection:"column"}} className='RowGapBasic4'>
                  <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>Nomor Telepon <span style={{color: "#c10000"}}>*</span></p>
                  <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                    <div className='SmallTextContainerInsideInputField BasicRadius ColumnGapBasic'>
                      <img src="/Assets/images/ButtonIcon/phone-black.svg" className='MidSizeIcon' />
                      <p className='MidSizeText2 InterMediumTextFont' style={{color:"#667085"}}>+62</p>
                    </div>
                    <input type="number" name="RoomPriceFrom" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="8123456789"/>
                  </div>
                  <div className='WarningTextImgWrapper ColumnGapBasic4'>
                    <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                    <p className='SmallSizeText InterMediumTextFont'>Wilayah Kota tidak boleh Kosong</p>
                  </div>
                  <div className="ColumnGapBasic4" style={{width:"fit-content", height:"fit-content", display:"flex"}}>
                    <label className="BasicToggleSwitch" style={{margin:"auto 0"}}>
                      <input type="checkbox" id="PhoneWhatsAppToggleCheckBox" wfd-id="id27"/>
                      <span className="slider round"></span>
                    </label>
                    <img src="/Assets/images/ButtonIcon/WhatsApp.svg" className='BiggerSizeIcon' style={{margin:"auto 0"}}/>
                    <p className="SmallSizeText InterMediumTextFont" style={{margin:"auto 0"}}>Nomor telepon ini memiliki WhatsApp</p>
                  </div>
                </div>


                <div style={{flex: 1, height:"fit-content", display:"flex", flexDirection:"column"}} className='RowGapBasic4'>
                  <p className="SmallSizeText InterMediumTextFont" style={{color:"#344054"}}>Nomor Whatsapp <span style={{color: "#c10000"}}>*</span></p>
                  <div className="BasicInputFieldContainer BasicRadius BasicGreyBorder"  style={{width: "100%", minWidth: "100%", display:"flex"}}>
                    <div className='SmallTextContainerInsideInputField BasicRadius ColumnGapBasic'>
                      <img src="/Assets/images/ButtonIcon/WhatsApp.svg" className='SlightlyBigSizeIcon' />
                      <p className='MidSizeText2 InterMediumTextFont' style={{color:"#667085"}}>+62</p>
                    </div>
                    <input type="number" name="RoomPriceFrom" className="InputFieldPadding MidSizeText2 InterMediumTextFont" placeholder="8123456789"/>
                  </div>
                  <div className='WarningTextImgWrapper ColumnGapBasic4'>
                    <img src="/Assets/images/ButtonIcon/warning-red.svg" />
                    <p className='SmallSizeText InterMediumTextFont'>Wilayah Kota tidak boleh Kosong</p>
                  </div>
                </div>

              </div>
              <div className='ColumnGapBasic2' style={{display:"flex", margin:"0 auto"}}>
                <button className='MidUIButton BasicRadius GreyOutlineButton ExtendedButton Selectable'>
                  <p className='InterMediumTextFont'>Kembali</p>
                </button>
                <button className='MidUIButton BasicRadius OrangeButton ExtendedButton Selectable'>
                  <p className='InterMediumTextFont'>Berikutnya</p>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="BasicBlackBlocker">
        <div className='FlexFullDisplayPanel HideScrollBar BasicRadius' style={{maxHeight:"none"}}>
          <div className='FlexContainerBaseAnimate RowGapBasic'>
            <div style={{width:"100%", height:"fit-content", margin:"0 auto", flexDirection:"column", display:"flex"}}>
              <img src="/Assets/images/ButtonIcon/cancel-x-grey.svg" className="CloseButtonInsidePanel" style={{marginLeft:"auto"}} />
            </div>
            <div className='SmallSizePopUpPanelWrapper RowGapBasic HideScrollBar RowGapBasic4'>
              <img src="/Assets/images/Icon/Accommodation_Submitted.png" className="HugeSizeIcon" style={{margin:"0 auto"}} />
              <p className='LessBigSizeText SpecialBigSizeLineHeight PoppinsBoldTextFont' style={{margin:"0 auto", textAlign:"center"}}>Akomodasi Berhasil Dikirim</p>
              <p className='MidSizeText2 PoppinsRegularTextFont' style={{margin:"0 auto", textAlign:"center"}}>Halo! Terima kasih telah mengirimkan data akomodasi Anda. Tim kami akan segera menghubungi Anda, dan akomodasi Anda akan segera tampil di platform kami.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExtraPageElements